<template>
  <modal
    name="completeModal"
    :click-to-close="false"
    :styles="styles"
    :width="480"
    :height="'auto'"
    @before-open="beforeOpen"
  >
    <complete-content
      :items="items"
      :doing-tasks="doingTasks"
    ></complete-content>
  </modal>
</template>

<script>
// this.$modal.show('completeModal', {files: []}) // files是已完成编辑文件列表
import CompleteContent from './completeContent';
export default {
  components: {
    CompleteContent
  },
  data() {
    return {
      items: [],
      doingTasks: {},
      styles: {
        borderRadius: 0,
        overflow: 'visible',
        backgroundColor: 'transparent',
        boxShadow: 'none'
      }
    };
  },
  created() {},
  beforeDestroy() {},
  methods: {
    close() {
      this.$modal.hide('completeModal');
    },
    beforeOpen(ev) {
      let { files = [], doingTasks = Promise.resolve() } = ev.params;
      this.items = files;
      this.doingTasks = doingTasks;
    }
  }
};
</script>

<style lang="scss" scoped>
.close-btn {
  position: absolute;
  left: calc(30px + 100%);
  top: 0;
  width: 60px;
  height: 60px;
  color: #fff;
  font-size: 20px;
  border-radius: 60px;
  background: rgba(#000, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
